export default "__VITE_ASSET__Lku$zAMH__"